import { useState, useEffect } from 'react';
import useUser from '../user/useUser';
import promotionsService from '../../services/promotionsService';

const useActivePromotions = (dayName) => {
    const { business, branch } = useUser();
    const [promotions, setPromotions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!branch?.code) return;

        setLoading(true);
        promotionsService
            .GetActives(business.id, branch.id, dayName)
            .then(res => {
                const data = Array.isArray(res) ? res : (res?.values ?? []);
                setPromotions(data);
            })
            .finally(() => setLoading(false));
    }, [branch?.code, dayName]);

    return { promotions, loading };
};

export default useActivePromotions;
